module.exports = __webpack_public_path__ + "static/img/item-shop-character.900a1eb.png";